import api from '@/utils/api';

/**
 * Update company option
 * @param {string} companyId - Company Id
 * @returns {Promise}
 */
const getCompanyTemplatesSelectApi = (companyId) =>
  api.get(`company/${companyId}/template/select`);

export default getCompanyTemplatesSelectApi;
